import { Table, TableData, TableHead, TableHeader } from "~/common/components";
import { SymptomsProgressionOverTime } from "~/providers/utils/types/patientIntakePreviewTypes";

interface PatientPreviewSymptomProgressionProps {
  symptomProgression: SymptomsProgressionOverTime[];
}

export const PatientPreviewSymptomProgressionV2 = ({
  symptomProgression,
}: PatientPreviewSymptomProgressionProps) => (
  <Table className="rounded-2xl border">
    <TableHead>
      <tr>
        <TableHeader className="rounded-ss-2xl px-6">Symptom</TableHeader>
        <TableHeader className="rounded-se-2xl px-6">Pattern</TableHeader>
      </tr>
    </TableHead>
    <tbody className="bg-white text-sm text-gray-70">
      {symptomProgression.map(({ symptom, pattern }) => (
        <tr key={symptom} className="rounded-b-2xl border-gray-300 py-4">
          <TableData className="rounded-b-2xl py-4 first-letter:uppercase">
            {symptom}
          </TableData>
          <TableData className="rounded-b-2xl py-4 first-letter:uppercase">
            {pattern}
          </TableData>
        </tr>
      ))}
    </tbody>
  </Table>
);
